<template>
    <main class="main restaurant" id="main">
        <navigate></navigate>
        <section class="section s-lk">
            <div class="container">
                <div class="lk_restaurant_form">
                    <div class="present_box form_box" v-if="present.id">
        <div class="top_part">
            <div class="info_row file">
                <span class="input_description" style="width: 0;max-width: 0;min-width: 0;">Логотип</span>

                <input class="file_input" id="file_avatar" name="file_avatar" type="file" ref="file" v-on:change="handleFileUpload()">
                <label for="file_avatar" :style="{height: '250px', width: '100%', backgroundSize: 'auto 100%', backgroundRepeat: 'no-repeat', backgroundImage: 'url(' + present.photo + ')'}"></label>
            </div>

            <div class="info_row">
                <span class="input_description">Страна</span>
                <select class="select_country select_info full" v-model="present.country_id">
                    <option v-if="present.country_ids" :value="(present.country_ids).toString()">{{present.country_name}}</option>
                </select>
            </div>

            <div class="info_row">
                <span class="input_description">Город</span>
                <select class="select_city select_info full" v-model="present.city_id">
                    <option v-if="present.city_ids" :value="(present.city_ids).toString()">{{present.city_name}}</option>
                </select>
            </div>
            <div class="info_row">
                <span class="input_description">Категория</span>
                <select class="select_info full select_category" v-model="present.category_id">
                    <option :value="index" v-for="(category, index) in present.categories" :key="index">{{category}}</option>
                </select>
            </div>

            <div class="info_row">
                <span class="input_description">Название</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="present.title">
            </div>

            <div class="info_row">
                <span class="input_description">Описание</span>
                <textarea class="textarea full" placeholder="Введите текст" v-model="present.text"></textarea>
            </div>

            <div class="info_row">
                <span class="input_description">Стоимость, бонусов</span>
                <input class="max" type="number" placeholder="Введите текст" v-model="present.price">
            </div>
            <div class="info_row">
                <span class="input_description">Тип оплаты бонусами</span>
                <select class="select_info full" v-model="present.pay_type">
                    <option value="full">Полная</option>
                    <option value="half">Частичная</option>
                </select>
            </div>
            <div class="info_row">
                <span class="input_description">E-Mail владельца</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="present.email">
            </div>

            <div class="info_row">
                <span class="input_description">Ссылка</span>
                <input class="max" type="text" placeholder="Введите текст" v-model="present.link">
            </div>

        </div>
        <button class="menu_item_btn" @click="saveData">Сохранить</button>

    </div>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import Inputmask from 'inputmask'
import axios from '@/router/http'
import Navigate from '@/pages/lk/user/navigate'
import $ from 'jquery'
import 'select2/dist/css/select2.min.css'
import 'select2'
export default {
  name: 'index',
  props: ['auth', 'user'],
  components: {Navigate},
  data () {
    return {
      present: {
        categories: []
      },
      citys: null,
      file: null
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.auth.uid) this.loadRest()
    else {
      setTimeout(() => {
        if (this.auth.uid) this.loadRest()
      }, 100)
    }
  },
  methods: {
    handleFileUpload () {
      var reader = new FileReader()
      reader.onload = (e) => {
        $('label[for="file_avatar"]').css('background-image', `url(${e.target.result})`)
        this.file = e.target.result
      }
      reader.readAsDataURL(this.$refs.file.files[0])
    },
    saveData () {
      console.log(JSON.parse(JSON.stringify(this.present)))
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('present', JSON.stringify(this.present))
      if (this.file !== null) formData.append('photo', this.file)
      axios.post('https://lk.when-hungry.com/mobile/save-present',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    },
    renderSelect () {
      let self = this
      $('.present_box .select_category').select2({}).on('select2:select', function () {
        self.present.category_id = $(this).val()
      })
      if (this.present.category_id) $('.present_box .select_category').val(this.present.category_id).trigger('change.select2')

      $('.present_box .select_country').select2({
        width: '100%',
        ajax: {
          url: 'https://lk.when-hungry.com/site/search-country',
          data: (params) => {
            params.q = params.term
            return params
          },
          dataType: 'json',
          processResults: function (data) {
            return {
              results: $.map(data, function (key, item) {
                return {
                  text: key,
                  id: item
                }
              })
            }
          }
        }
      }).val(this.present.country_id.toString()).trigger('change.select2').on('select2:select', function () {
        self.present.country_id = $(this).val()
        self.present.city_id = null
        $('.present_box .select_city').val(null).trigger('change.select2')
      })
      $('.present_box .select_city').select2({
        width: '100%',
        ajax: {
          url: 'https://lk.when-hungry.com/site/search-city',
          data: (params) => {
            params.id = this.present.country_id ? this.present.country_id : this.$root.city.country_id
            params.q = params.term
            params.all = 1
            params.country = 1
            params.comm = 1
            return params
          },
          dataType: 'json',
          processResults: function (data) {
            return {
              results: $.map(data, function (key, item) {
                return {
                  text: key,
                  id: item
                }
              })
            }
          }
        }
      }).val(this.present.city_id.toString()).trigger('change.select2').on('select2:select', function () {
        self.present.city_id = $(this).val()
      })
    },
    loadRest () {
      if (this.id !== null) {
        axios.get('https://lk.when-hungry.com/mobile/get-present?uid=' + this.auth.uid + '&id=' + this.id).then(response => {
          this.present = response.data
          Inputmask().remove(document.getElementById('input'))
          setTimeout(() => {
            Inputmask().mask(document.querySelectorAll('input'))
            this.renderSelect()
          }, 500)
        })
      }
    }
  },
  watch: {
    $route (to, from) {
      this.id = to.params.id
      this.loadRest()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/user/present.vue